import type { AnimationState, TransformState, TransitionConfig, TargetShape } from '../types'
import { DEFAULT_TRANSFORM, DEFAULT_TRANSITION } from '../constants'

interface CompactConfig {
  t?: Partial<TransformState>
  tr?: Partial<TransitionConfig>
  s?: TargetShape
}

export type LoadConfigPayload = {
  transform?: Partial<TransformState>
  transition?: Partial<TransitionConfig>
  targetShape?: TargetShape
}

function diffTransform(transform: TransformState): Partial<TransformState> | undefined {
  const diff: Partial<TransformState> = {}
  let hasChanges = false
  for (const key of Object.keys(DEFAULT_TRANSFORM) as (keyof TransformState)[]) {
    if (transform[key] !== DEFAULT_TRANSFORM[key]) {
      diff[key] = transform[key]
      hasChanges = true
    }
  }
  return hasChanges ? diff : undefined
}

function diffTransition(transition: TransitionConfig): Partial<TransitionConfig> | undefined {
  const diff: Partial<TransitionConfig> = {} as any
  let hasChanges = false

  if (transition.type !== DEFAULT_TRANSITION.type) {
    diff.type = transition.type
    hasChanges = true
  }

  // Always include the active transition config
  diff[transition.type] = transition[transition.type] as any
  hasChanges = true

  return hasChanges ? diff : undefined
}

export function encodeConfig(state: AnimationState): string {
  const compact: CompactConfig = {}

  const tDiff = diffTransform(state.transform)
  if (tDiff) compact.t = tDiff

  const trDiff = diffTransition(state.transition)
  if (trDiff) compact.tr = trDiff

  if (state.targetShape !== 'box') compact.s = state.targetShape

  return btoa(JSON.stringify(compact))
}

export function decodeConfig(param: string): LoadConfigPayload | null {
  try {
    const compact: CompactConfig = JSON.parse(atob(param))
    const payload: LoadConfigPayload = {}

    if (compact.t) payload.transform = compact.t
    if (compact.tr) payload.transition = compact.tr
    if (compact.s) payload.targetShape = compact.s

    return payload
  } catch {
    return null
  }
}

export function buildShareUrl(state: AnimationState): string {
  const encoded = encodeConfig(state)
  const url = new URL(window.location.href)
  url.search = ''
  url.searchParams.set('config', encoded)
  return url.toString()
}
